import { css, styled } from "@mui/material";

import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const Wrapper = styled("div")(
  ({ theme }) => css`
    margin: 0 auto;
    position: relative;

    ${theme.breakpoints.down("desktop")} {
      height: calc(9800px + 100vh / 2);
      padding-top: 200px;
      margin-bottom: calc(-0.8 * 100vh + 500px);
    }

    ${theme.breakpoints.down("tablet")} {
      margin-bottom: calc(-0.8 * 100vh + 500px);
    }

    ${theme.breakpoints.up("desktop")} {
      width: 100vw;
      height: 1300px;
      margin-top: 200px;
      margin-bottom: 100px;
      overflow-x: clip;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: 100vw;
      height: min-content;
      margin-top: 300px;
    }
  `,
);

export const Wrapper2 = styled("div")(
  ({ theme }) => css`
    margin: 0 auto;
    width: 1431px;

    ${theme.breakpoints.down("desktopXl")} {
      width: 1023px;
    }

    ${theme.breakpoints.down("desktop")} {
      height: 100vh;
      position: sticky;
      top: 350px;
      width: 100vw;
      overflow-x: clip;
    }

    ${theme.breakpoints.down("tablet")} {
      top: 200px;
    }
  `,
);

interface TransformProps {
  top: string;
  left: string;
}

export const smallDesktopScale = 0.715;

export const Container = styled("div", {
  shouldForwardProp: prop => !["top", "left"].includes(prop as string),
})<TransformProps>(
  ({ theme, top, left }) => css`
    transform-origin: top left;
    transform: translate(${left}, ${top});
    transition: transform 1s;

    ${theme.breakpoints.between("desktop", "desktopXl")} {
      transform: scale(${smallDesktopScale});
    }

    ${theme.breakpoints.up("desktopXl")} {
      transform: scale(1);
    }
  `,
);

export const ProcessHeader = styled("div")(
  ({ theme }) => css`
    > * {
      ${theme.breakpoints.up("mobile")} {
        margin: 0 16px;
      }

      ${theme.breakpoints.up("tablet")} {
        margin: 0 auto;
        max-width: 640px;
      }

      ${theme.breakpoints.up("desktop")} {
        max-width: 800px;
      }

      ${theme.breakpoints.up("desktopXl")} {
        max-width: 1000px;
      }
    }

    text-align: center;
    padding: 32px 0;
    background: radial-gradient(
      50% 44.06% at 50% 0%,
      rgba(45, 238, 125, 0.12) 0%,
      rgba(118, 210, 204, 0) 100%
    );

    ${theme.breakpoints.up("mobile")} {
      margin: -24px 0;
      ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    }

    ${theme.breakpoints.up("tablet")} {
      margin: -32px 0;
      ${cssPropertiesToString(theme.typography.paragraph_large_medium)}
    }

    ${theme.breakpoints.up("desktop")} {
      margin: -64px 0;
      ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
    }

    h2 {
      ${cssForHeaderWithLinearGradient(theme)}

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_mobile)}
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
      }
    }
  `,
);
